/**
 * @generated SignedSource<<60c05f4feabe5a739193bddb61b94350>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type TagUUIDRedirectQuery$variables = {
  id: string;
  isGlobalId: boolean;
};
export type TagUUIDRedirectQuery$data = {
  readonly tag?: {
    readonly uuid: string | null;
  } | null;
};
export type TagUUIDRedirectQuery = {
  response: TagUUIDRedirectQuery$data;
  variables: TagUUIDRedirectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isGlobalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "uuid"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TagUUIDRedirectQuery",
    "selections": [
      {
        "condition": "isGlobalId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tag",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TagUUIDRedirectQuery",
    "selections": [
      {
        "condition": "isGlobalId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tag",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "063b43890121e93fcdb70a0b140a89e9",
    "id": null,
    "metadata": {},
    "name": "TagUUIDRedirectQuery",
    "operationKind": "query",
    "text": "query TagUUIDRedirectQuery(\n  $id: ID!\n  $isGlobalId: Boolean!\n) {\n  tag(id: $id) @include(if: $isGlobalId) {\n    uuid\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "afdb324454f8dc219b26ca625679f486";

export default node;
